import React, { useEffect, useRef, useState } from "react"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import {
  Col,
  Row,
  Card,
  UncontrolledPopover,
  PopoverBody,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap"
import UpdateTable from "../../../components/Common/UpdatedTable"
import { toastSuccess } from "../../../helpers/msg_helper"
import closeIcon from "../../../assets/icons/close.svg"
import { updateCustomerStatus } from "../../../services/projectManager/customer"
import {
  fetchFinanceBankReconciliation,
  postFinanceBankDate,
} from "../../../services/finance/finance"
import BankReconciliationFilter from "./filter"
import moment from "moment"
import NumberFormat from "../../../utils/numberFormat"
import MobileNumberFormat from "../../../utils/mobilenumberformat"
import { createSelector } from "reselect"
import { useSelector } from "react-redux"
import { UFDate } from "../../../components/Common/Fields/Input"
import { useForm } from "react-hook-form"

const BankReconciliation = () => {
  const companyname = localStorage.getItem("companyname")
  document.title = `Bank Reconciliation${
    companyname ? ` | ${companyname}` : ""
  }`
  const [editClass, setEditClass] = useState({
    modal: false,
    value: "",
    id: "",
  })

  const selectLoginState = state => state.Login
  const LoginProperties = createSelector(selectLoginState, login => ({
    loggedUser: login.loggedUser,
  }))

  const { loggedUser } = useSelector(LoginProperties)
  const desimalrange = localStorage.getItem("desimalrange")

  const [refresh, setRefresh] = useState(0)
  const [viewData, setViewData] = useState()
  const [modal, setModal] = useState(false)

  const toggle = () => setModal(!modal)

  const handleUpdate = () => {
    setRefresh(refresh + 1)
  }
  const handleReset = () => {
    setEditClass({
      modal: false,
      value: "",
      id: "",
    })
  }

  const [classData, setClassData] = useState()
  const [status, setStatus] = useState("")
  const [search, setSearch] = useState("")
  const [customerType, setCustomerType] = useState("")
  const [voucherChange, setVoucherChange] = useState("")
  const [page, setPage] = useState("")
  const [financial, setFinancial] = useState(true)
  const [datefrom, setDatefrom] = useState("")
  const [dateto, setDateto] = useState("")
  const [isLoadingNextPage, setIsLoadingNextPage] = useState(false)

  const handleEdit = item => {
    setEditClass({ modal: false, value: item, id: item?.id })
  }
  const handleView = item => {
    setViewData(item)
    toggle()
  }
  const handleActivate = item => {
    const updateStatus = async item => {
      const response = await updateCustomerStatus(item)
      toastSuccess(response?.message)
      setRefresh(refresh + 1)
    }
    updateStatus(item)
  }

  const handleRowDateChange = async (id, date) => {
    // const updateDate = async (id, date) => {
    console.log(`id, date`, id, date)

    const response = await postFinanceBankDate({
      id: id,
      date: moment(date[0]).format("YYYY-MM-DD"),
    })
    toastSuccess(response?.message)
    setRefresh(refresh + 1)
    // }
  }

  // const { control } = useForm()
  const defaultValues = {}
  // if (classData?.data?.data) {
  //   classData.data.data.forEach(item => {
  //     defaultValues[`update_date_${item.id}`] = item?.bank_payments?.[0]?.date
  //       ? moment(item.bank_payments[0].date, "YYYY-MM-DD").toDate()
  //       : null
  //   })
  // }
  const { control, reset } = useForm({ defaultValues })

  useEffect(() => {
    if (classData?.data?.data) {
      const newDefaults = {}
      classData.data.data.forEach(item => {
        newDefaults[`update_date_${item.id}`] = item?.bank_payments?.[0]?.date
          ? moment(item.bank_payments[0]?.date, "YYYY-MM-DD").toDate()
          : null
      })
      reset(newDefaults)
    }
  }, [classData, reset])

  const columns = [
    {
      label: "Date",
      renderCell: item =>
        moment(item?.journal_entries?.transaction_date).format("DD-MMM-YYYY"),
    },
    // {
    //   label: "Description",
    //   renderCell: item => item?.ledger?.name,
    // },
    {
      label: "Voucher Type",
      renderCell: item => {
        return <div>{item?.voucher_type}</div>
      },
    },
    {
      label: "Voucher Number",
      renderCell: item => {
        return <div>{item?.voucher_entry?.ref_number}</div>
      },
    },
    {
      label: "Instrument Type",
      renderCell: item => {
        return (
          <div>
            {item?.bank_payments[0]?.payment_type_value?.value
              ? item?.bank_payments[0]?.payment_type_value?.value
              : "-"}
          </div>
        )
      },
    },
    {
      label: "Instrument Number",
      renderCell: item => {
        return (
          <div>
            {item?.bank_payments[0]?.instrument_no
              ? item?.bank_payments[0]?.instrument_no
              : "-"}
          </div>
        )
      },
    },
    {
      label: "Instrument Date",
      renderCell: item => {
        return (
          <div>
            {moment(
              item?.bank_payments[0]?.instrument_date ||
                item?.journal_entries?.transaction_date
            ).format("DD-MMM-YYYY")}
          </div>
        )
      },
    },
    {
      label: "Bank Date",
      renderCell: item => {
        // const bankDate = item?.bank_payments?.[0]?.date
        //   ? moment(item.bank_payments[0].date, "YYYY-MM-DD").toDate()
        //   : null
        // console.log(`bankDate`, bankDate, item.bank_payments[0].date)

        return (
          <div>
            <UFDate
              control={control}
              // value={bankDate}
              // value={item?.bank_payments[0]?.date ? moment(item?.bank_payments[0]?.date, "YYYY-MM-DD").toDate() : null}
              onDateChange={date =>
                handleRowDateChange(item?.bank_payments[0]?.id, date)
              }
              placeholder="Select Date"
              name={`update_date_${item.id}`}
              className="form-control"
            />
            {/* {item?.bank_payments[0]?.instrument_date
              ? moment(item?.bank_payments[0]?.instrument_date).format(
                  "DD-MMM-YYYY"
                )
              : "-"} */}
          </div>
        )
      },
    },
    {
      label: <div className="text-end pe-5">Debit</div>,
      renderCell: item => (
        <div className="text-end pe-5">
          {NumberFormat(Number(item?.debit_amount), desimalrange, desimalrange)}
        </div>
      ),
    },
    {
      label: <div className="text-end pe-5">Credit</div>,
      renderCell: item => (
        <div className="text-end pe-5">
          {NumberFormat(
            Number(item?.credit_amount),
            desimalrange,
            desimalrange
          )}
        </div>
      ),
    },
  ]

  const handlePaginate = page => {
    setPage(page)
  }

  useEffect(() => {
    const fetchClass = async () => {
      const response = await fetchFinanceBankReconciliation({
        params: `${status == "0" || status == "1" ? `&status=${status}` : ""}${
          search ? `&searchText=${search}` : "&searchText"
        }${
          customerType == "0" || customerType == "1"
            ? `&customer_type=${customerType}`
            : ""
        }${page ? `&page=${page}` : ""}${
          voucherChange ? `&ledger_id=${voucherChange}` : ""
        }${datefrom ? `&start_date=${datefrom}` : ""}${
          dateto ? `&end_date=${dateto}` : ""
        }`,
      })
      // setClassData(response)
      const newData = response?.data?.data || []

      setClassData(prev =>
        page > 1 && prev
          ? {
              ...response,
              data: {
                ...response.data,
                data: [...(prev.data?.data || []), ...newData],
              },
            }
          : response
      )
      setIsLoadingNextPage(response == undefined ? true : false)
      isLoadingRef.current = false
      // ${`&financial=${financial}`}
    }
    if (voucherChange) {
      fetchClass()
    }
  }, [
    refresh,
    status,
    search,
    customerType,
    page,
    financial,
    voucherChange,
    datefrom,
    dateto,
  ])

  const tableContainerRef = useRef(null)
  const isLoadingRef = useRef(false)
  const scrollTimeoutRef = useRef(null)

  useEffect(() => {
    const handleScroll = e => {
      const { scrollTop, scrollHeight, clientHeight } = e.target

      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current)
      }

      scrollTimeoutRef.current = setTimeout(() => {
        if (
          scrollTop + clientHeight >= scrollHeight - 50 &&
          !isLoadingRef.current &&
          page < classData?.data?.last_page
        ) {
          isLoadingRef.current = true
          setIsLoadingNextPage(true)
          setPage(prev => prev + 1)
        }
      }, 200)
    }

    const container = tableContainerRef.current
    if (container) {
      container.addEventListener("scroll", handleScroll)
    }

    return () => {
      if (container) {
        container.removeEventListener("scroll", handleScroll)
      }
      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current)
      }
    }
  }, [classData, page])

  const handleStatusChange = id => {
    setStatus(id)
    setPage(1)
  }

  const handleCatChange = id => {
    setCustomerType(id)
    setPage(1)
  }
  const handleSearchChange = data => {
    setSearch(data)
    setPage(1)
  }

  const handleFinacialChange = id => {
    setFinancial(id)
    setPage(1)
  }
  const handleVoucherChange = id => {
    if (id == undefined) {
      setClassData()
    }
    setVoucherChange(id)
    setPage(1)
  }

  const handleDateChange = (fromdate, todate) => {
    setDatefrom(fromdate)
    setDateto(todate)
    setPage(1)
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <div className="d-flex justify-content-between">
            <Breadcrumbs
              title="Finance"
              breadcrumbObject={[
                { title: "Finance", link: "/finance" },
                {
                  title: "Bank Reconciliation",
                  link: "/finance-bank-reconciliation",
                },
              ]}
            />
            {classData?.data?.data?.length ? (
              <div className="ms-2">
                <div className="me-2">
                  <span id={`PopoverLegacy-1`} className="px-2 btn btn-primary">
                    Download
                  </span>
                </div>
                <UncontrolledPopover
                  placement="bottom"
                  target={`PopoverLegacy-1`}
                  trigger="legacy"
                >
                  <PopoverBody>
                    <div
                      className="table-popup-content"
                      // onClick={() => {
                      //   let ageingArr = []
                      //   if (ageingPeriod?.length > 0) {
                      //     ageingArr = ageingPeriod.map(period => ({
                      //       label:
                      //         period?.to_days === 0
                      //           ? `pending_over_${period?.from_days}_days`
                      //           : `pending_${period?.from_days}_to_${period?.to_days}_days`,
                      //       min:
                      //         period?.from_days === 0 ? null : period?.from_days,
                      //       max: period?.to_days === 0 ? null : period?.to_days,
                      //     }))
                      //   }

                      //   const params = `${
                      //     path?.includes("recievable")
                      //       ? `&account_id=13`
                      //       : `&account_id=22`
                      //   }${dueOn ? `&due_on=${dueOn}` : ""}${`&type=${
                      //     agingCheck
                      //       ? "Ageing"
                      //       : rSelected == 1
                      //       ? "Default"
                      //       : rSelected == 2
                      //       ? "Detailed"
                      //       : "Ageing"
                      //   }`}&sortOrder=asc${
                      //     ageingArr?.length
                      //       ? `&${ageingArr
                      //           .map(
                      //             (item, i) =>
                      //               `pending_buckets[${i}][label]=${item.label}&pending_buckets[${i}][min]=${item.min}&pending_buckets[${i}][max]=${item.max}`
                      //           )
                      //           .join("&")}`
                      //       : ""
                      //   }`

                      //   downloadFinanceReceivable({
                      //     params,
                      //     type: "pdf",
                      //     fileName: "statement_of_account.pdf",
                      //   })
                      // }}
                    >
                      PDF
                    </div>
                    <div
                      className="table-popup-content"
                      // onClick={() => {
                      //   let ageingArr = []
                      //   if (ageingPeriod?.length > 0) {
                      //     ageingArr = ageingPeriod.map(period => ({
                      //       label:
                      //         period?.to_days === 0
                      //           ? `pending_over_${period?.from_days}_days`
                      //           : `pending_${period?.from_days}_to_${period?.to_days}_days`,
                      //       min:
                      //         period?.from_days === 0 ? null : period?.from_days,
                      //       max: period?.to_days === 0 ? null : period?.to_days,
                      //     }))
                      //   }

                      //   const params = `${
                      //     path?.includes("recievable")
                      //       ? `&account_id=13`
                      //       : `&account_id=22`
                      //   }${dueOn ? `&due_on=${dueOn}` : ""}${`&type=${
                      //     agingCheck
                      //       ? "Ageing"
                      //       : rSelected == 1
                      //       ? "Default"
                      //       : rSelected == 2
                      //       ? "Detailed"
                      //       : "Ageing"
                      //   }`}&sortOrder=asc${
                      //     ageingArr?.length
                      //       ? `&${ageingArr
                      //           .map(
                      //             (item, i) =>
                      //               `pending_buckets[${i}][label]=${item.label}&pending_buckets[${i}][min]=${item.min}&pending_buckets[${i}][max]=${item.max}`
                      //           )
                      //           .join("&")}`
                      //       : ""
                      //   }`

                      //   downloadFinanceReceivable({
                      //     params,
                      //     type: "excel",
                      //     fileName: "statement_of_account.xlsx",
                      //   })
                      // }}
                    >
                      Excel
                    </div>
                  </PopoverBody>
                </UncontrolledPopover>
              </div>
            ) : (
              <></>
            )}
          </div>
          <Card className="me-2 px-2 pb-2">
            <BankReconciliationFilter
              handleStatusChange={handleStatusChange}
              handleSearchChange={handleSearchChange}
              handleCatChange={handleCatChange}
              handleFinacialChange={handleFinacialChange}
              handleVoucherChange={handleVoucherChange}
              handleDateChange={handleDateChange}
              sampleUrl={"download/customer.xlsx"}
              importUrl={"customer/import"}
              isImport={false}
            />
            <hr className="table-divide" />
            <Row className="mt-2 ever-rise-table">
              <Col xs={12}>
                <div
                  ref={tableContainerRef}
                  style={{ maxHeight: "385px", overflowY: "auto" }}
                >
                  {classData ? (
                    <UpdateTable
                      className="mt-5"
                      nodes={classData?.data?.data}
                      paginate={classData?.data}
                      columns={columns}
                      CurrentPage={page}
                      handlePagination={handlePaginate}
                      tableWidth="8%  12% 10% 10% 10% 10% 14% 13% 13%"
                      mobileWidth="30% 30% 30% 30%"
                      isLoading={isLoadingNextPage}
                      hidePaginate={true}
                    />
                  ) : (
                    <div className="d-flex align-items-center justify-content-center">
                      <p>Please select a ledger.</p>
                    </div>
                  )}
                </div>
              </Col>
              {classData ? (
                <Row className="mt-2">
                  <Col lg={5}></Col>
                  <Col lg={7} className="text-muted">
                    <Row className="fw-bold">
                      <Col lg={6}>Current Total</Col>
                      <Col lg={3} className="text-end pe-5 fw-bold">
                        {NumberFormat(
                          Math.abs(Number(classData?.totals?.bank_debit || 0)),
                          desimalrange,
                          desimalrange
                        )}
                      </Col>
                      {/* <Col lg={3} className="text-end pe-5 fw-bold">
                        {NumberFormat(
                          Math.abs(
                            Number(
                              classData?.totals
                                ?.amounts_not_reflected_in_bank_debit || 0
                            ) -
                              Number(
                                classData?.totals?.company_books_debit || 0
                              )
                          ),
                          desimalrange,
                          desimalrange
                        )}
                      </Col> */}
                      <Col lg={3} className="text-end pe-5 fw-bold">
                        {NumberFormat(
                          Math.abs(Number(classData?.totals?.bank_credit || 0)),
                          desimalrange,
                          desimalrange
                        )}
                      </Col>
                      {/* <Col lg={3} className="text-end pe-5 fw-bold">
                        {NumberFormat(
                          Math.abs(
                            Number(
                              classData?.totals
                                ?.amounts_not_reflected_in_bank_credit || 0
                            ) -
                              Number(
                                classData?.totals?.company_books_credit || 0
                              )
                          ),
                          desimalrange,
                          desimalrange
                        )}
                      </Col> */}
                      {/* <Col lg={4} className="text-end pe-5 fw-bold">
                        {NumberFormat(
                          Math.abs(Number(classData?.currentCredit || 0)),
                          desimalrange,
                          desimalrange
                        )}
                      </Col> */}
                    </Row>
                    <Row>
                      <Col lg={6}>Balance As per Bank Book</Col>
                      <Col lg={3} className="text-end pe-5 fw-bold">
                        {/* {classData?.openingBalance_type == "debit"
                          ?  */}
                        {Number(classData?.totals?.opening_balance || 0) +
                          Number(classData?.totals?.company_books_debit || 0) -
                          Number(classData?.totals?.company_books_credit || 0) >
                        0
                          ? NumberFormat(
                              Math.abs(
                                Number(
                                  classData?.totals?.opening_balance || 0
                                ) +
                                  Number(
                                    classData?.totals?.company_books_debit || 0
                                  ) -
                                  Number(
                                    classData?.totals?.company_books_credit || 0
                                  )
                              ),
                              desimalrange,
                              desimalrange
                            )
                          : ""}
                        {/* : "-"} */}
                      </Col>
                      <Col lg={3} className="text-end pe-5 fw-bold">
                        {/* {classData?.openingBalance_type == "debit"
                          ?  */}
                        {Number(classData?.totals?.opening_balance || 0) +
                          Number(classData?.totals?.company_books_debit || 0) -
                          Number(classData?.totals?.company_books_credit || 0) <
                        0
                          ? NumberFormat(
                              Math.abs(
                                Number(
                                  classData?.totals?.company_books_credit || 0
                                )
                              ),
                              desimalrange,
                              desimalrange
                            )
                          : ""}
                        {/* : "-"} */}
                      </Col>
                      {/* <Col lg={4} className="text-end pe-5 fw-bold">
                        {classData?.openingBalance_type == "credit"
                          ? NumberFormat(
                              Math.abs(Number(classData?.openingBalance || 0)),
                              desimalrange,
                              desimalrange
                            )
                          : "-"}
                      </Col> */}
                    </Row>
                    <Row className="my-2">
                      <Col lg={6}>Amount Not Reflected in Bank</Col>
                      <Col lg={3} className="text-end pe-5 fw-bold">
                        {Number(
                          classData?.totals
                            ?.amounts_not_reflected_in_bank_debit || 0
                        ) -
                          Number(
                            classData?.totals
                              ?.amounts_not_reflected_in_bank_credit || 0
                          ) >
                        0
                          ? NumberFormat(
                              Math.abs(
                                Number(
                                  classData?.totals
                                    ?.amounts_not_reflected_in_bank_debit || 0
                                )
                              ),
                              desimalrange,
                              desimalrange
                            )
                          : ""}
                      </Col>
                      <Col lg={3} className="text-end pe-5 fw-bold">
                        {Number(
                          classData?.totals
                            ?.amounts_not_reflected_in_bank_debit || 0
                        ) -
                          Number(
                            classData?.totals
                              ?.amounts_not_reflected_in_bank_credit || 0
                          ) <
                        0
                          ? NumberFormat(
                              Math.abs(
                                Number(
                                  classData?.totals
                                    ?.amounts_not_reflected_in_bank_credit || 0
                                )
                              ),
                              desimalrange,
                              desimalrange
                            )
                          : ""}
                      </Col>
                    </Row>
                    <Row className="my-2">
                      <Col lg={6}>Balance as per Bank</Col>
                      <Col lg={3} className="text-end pe-5 fw-bold">
                        {/* {classData?.closingBalance_type == "debit"
                          ?  */}
                        {Number(classData?.totals?.opening_balance || 0) +
                          Number(classData?.totals?.bank_debit || 0) -
                          Number(classData?.totals?.bank_credit || 0) >
                        0
                          ? NumberFormat(
                          Math.abs(Number(classData?.totals?.bank_debit || 0)),
                          desimalrange,
                          desimalrange
                        ) : ""}
                        {/* : "-"} */}
                      </Col>
                      <Col lg={3} className="text-end pe-5 fw-bold">
                        {/* {classData?.closingBalance_type == "debit"
                          ?  */}
                        {Number(classData?.totals?.opening_balance || 0) +
                          Number(classData?.totals?.bank_debit || 0) -
                          Number(classData?.totals?.bank_credit || 0) <
                        0
                          ? NumberFormat(
                          Math.abs(Number(classData?.totals?.bank_credit || 0)),
                          desimalrange,
                          desimalrange
                        ) : ""}
                        {/* : "-"} */}
                      </Col>
                      {/* <Col lg={4} className="text-end pe-5">
                        {classData?.closingBalance_type == "credit"
                          ? NumberFormat(
                              Math.abs(Number(classData?.closingBalance || 0)),
                              desimalrange,
                              desimalrange
                            )
                          : "-"}
                      </Col> */}
                    </Row>
                  </Col>
                </Row>
              ) : (
                <></>
              )}
            </Row>
          </Card>
        </div>
      </div>
      <Modal isOpen={modal} toggle={toggle} size="lg" unmountOnClose={false}>
        <>
          <ModalHeader className="custom-modal-header">
            <div className="d-flex justify-content-between">
              <h5 className="ms-4">Details</h5>
              <img
                src={closeIcon}
                alt=""
                onClick={toggle}
                width="10"
                role="button"
              />
            </div>
          </ModalHeader>
          <ModalBody>
            <Row className="py-3 ms-3">
              <Col lg={3} className="secondary-text">
                Customer Type
              </Col>
              <Col className="primary-text">
                {viewData?.customer_type?.label}
              </Col>
            </Row>
            <Row className="py-3 ms-3">
              <Col lg={3} className="secondary-text">
                Customer Code
              </Col>
              <Col className="primary-text">{viewData?.customer_code}</Col>
            </Row>
            <Row className="py-3 ms-3">
              <Col lg={3} className="secondary-text">
                Customer Name
              </Col>
              <Col className="primary-text">
                <div className="capitalize-letter">
                  {viewData?.customer_name}
                </div>
              </Col>
            </Row>
            <Row className="py-3 ms-3">
              <Col lg={3} className="secondary-text">
                Email ID
              </Col>
              <Col className="primary-text">{viewData?.email_id}</Col>
            </Row>
            <Row className="py-3 ms-3">
              <Col lg={3} className="secondary-text">
                Contact Person
              </Col>
              <Col className="primary-text">
                <div className="capitalize-letter">
                  {viewData?.contact_person}
                </div>
              </Col>
            </Row>
            <Row className="py-3 ms-3">
              <Col lg={3} className="secondary-text">
                Contact Number
              </Col>
              <Col className="primary-text">
                {MobileNumberFormat("+" + viewData?.customer_number)}
              </Col>
            </Row>
            <Row className="py-3 ms-3">
              <Col lg={3} className="secondary-text">
                Designation
              </Col>
              <Col className="primary-text">
                <div className="capitalize-letter">
                  {viewData?.contact_person_designation}
                </div>
              </Col>
            </Row>
            {viewData?.contact_person_two != null && (
              <Row className="py-3 ms-3">
                <Col lg={3} className="secondary-text">
                  Contact Person Two
                </Col>
                <Col className="primary-text">
                  <div className="capitalize-letter">
                    {viewData?.contact_person_two}
                  </div>
                </Col>
              </Row>
            )}
            {viewData?.customer_number_two != null && (
              <Row className="py-3 ms-3">
                <Col lg={3} className="secondary-text">
                  Contact Number Two
                </Col>
                <Col className="primary-text">
                  {MobileNumberFormat("+" + viewData?.customer_number_two)}
                </Col>
              </Row>
            )}
            {viewData?.contact_person_designation_two != null && (
              <Row className="py-3 ms-3">
                <Col lg={3} className="secondary-text">
                  Designation Two
                </Col>
                <Col className="primary-text">
                  <div className="capitalize-letter">
                    {viewData?.contact_person_designation_two}
                  </div>
                </Col>
              </Row>
            )}

            <Row className="py-3 ms-3">
              <Col lg={3} className="secondary-text">
                Address
              </Col>
              <Col className="primary-text">
                <div className="capitalize-letter">{viewData?.address}</div>
              </Col>
            </Row>
          </ModalBody>
        </>
      </Modal>
    </React.Fragment>
  )
}

export default BankReconciliation
